import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { BaseButton, } from '../Button/Button.base';
const boxShadowHorizontalOffset = 0;
const boxShadowVerticalOfset = 2;
const boxShadowBlurRadius = 11;
const boxShadowSpreadRadius = 0;
const BaseFloatingActionButton = ({ ariaDescribedBy, ariaLabel, ariaLabelledBy, ariaPressed, bottom = 0, customIcon, disabled, iconAlignment, iconType, isFloating = false, left = 0, loading, offset = 0, onBlur, onClick, onFocus, onKeyDown, onKeyUp, onMouseDown, onMouseLeave, onMouseUp, onTouchEnd, onTouchMove, onTouchStart, position = 'bottomCenter', right = 0, text, top = 0, zIndex = 9999, }) => {
    const floatingActionButtonContainerStyles = useMemo(() => css `
      border-radius: ${theme.spacing.x6};

      ${isFloating && css `
        box-shadow: ${styleUtils.rem(boxShadowHorizontalOffset)} ${styleUtils.rem(boxShadowVerticalOfset)} ${styleUtils.rem(boxShadowBlurRadius)} ${styleUtils.rem(boxShadowSpreadRadius)} rgba(0, 0, 0, 0.15);
        position: fixed;
        z-index: ${zIndex};

        ${position === 'bottomCenter' && `
          bottom: ${styleUtils.rem(offset + bottom)};
          left: calc(50% + ${styleUtils.rem(left - right)});
          transform: translateX(-50%);
        `}
        ${position === 'bottomLeft' && `
          bottom: ${styleUtils.rem(offset + bottom)};
          left: ${styleUtils.rem(offset + left)};
        `}
        ${position === 'bottomRight' && `
          bottom: ${styleUtils.rem(offset + bottom)};
          right: ${styleUtils.rem(offset + right)};
        `}
        ${position === 'center' && `
          left: calc(50% + ${styleUtils.rem(left - right)});
          top: calc(50% + ${styleUtils.rem(top - bottom)});
          transform: translate(-50%, -50%);
        `}
        ${position === 'centerLeft' && `
          left: ${styleUtils.rem(offset + left)};
          top: calc(50% + ${styleUtils.rem(top - bottom)});
          transform: translateY(-50%);
        `}
        ${position === 'centerRight' && `
          right: ${styleUtils.rem(offset + right)};
          top: calc(50% + ${styleUtils.rem(top - bottom)});
          transform: translateY(-50%);
        `}
        ${position === 'topCenter' && `
          top: ${styleUtils.rem(offset + top)};
          left: calc(50% + ${styleUtils.rem(left - right)});
          transform: translateX(-50%);
        `}
        ${position === 'topLeft' && `
          top: ${styleUtils.rem(offset + top)};
          left: ${styleUtils.rem(offset + left)};
        `}
        ${position === 'topRight' && `
          top: ${styleUtils.rem(offset + top)};
          right: ${styleUtils.rem(offset + right)};
        `}
      `}
    `, [
        bottom,
        isFloating,
        left,
        offset,
        position,
        right,
        top,
        zIndex,
    ]);
    return (_jsx(BaseButton, { ariaDescribedBy: ariaDescribedBy, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, ariaPressed: ariaPressed, css: floatingActionButtonContainerStyles, customIcon: customIcon, disabled: disabled, iconAlignment: iconAlignment, iconType: iconType, loading: loading, onBlur: onBlur, onClick: onClick, onFocus: onFocus, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onMouseDown: onMouseDown, onMouseLeave: onMouseLeave, onMouseUp: onMouseUp, onTouchEnd: onTouchEnd, onTouchMove: onTouchMove, onTouchStart: onTouchStart, size: "large", text: text, type: "primary" }));
};
const MemoizedFloatingActionButton = memo(BaseFloatingActionButton);
export { MemoizedFloatingActionButton as BaseFloatingActionButton };
// MC-1068 Temporary hack for Storybook.
export default BaseFloatingActionButton;
